import React from "react";
import { getBaseColumns, getPacsSpecificColumns, renderActionColumn, calculateActionsColumnWidth } from "../../utils/sharedTableColumns";
import { getUserDetails } from "../../utils/helper";
import { FieldLabels } from "../../constants/fieldLabels";

export const orderColumns = ({
  openViewer,
  showOrdDetails,
  openRadDesk,
  openReportEditor,
  role,
  addFile,
  viewNotes,
  printReport,
  downloadDocxReport,
  viewReport,
  editSignedOffReport,
  assignToSelfTechnician,
  toggleReporting,
  toggleConfirmation,
  toggleFeatures,
  handleShareStudy,
  handleDownloadStudy,
  editStudyDetails,
  showStudyHistory,
  handleRadiologistAssignment,
  userList,
  openRadiantViewer,
  enableRadiantViewer
}) => {
  const userDetails = getUserDetails();
  const baseColumns = getBaseColumns();
  const pacsSpecificColumns = getPacsSpecificColumns();

  // Customize patient name column to include openReportEditor and Radiant Viewer
  const patientNameColumn = baseColumns.find(col => col.key === 'pat_name');
  if (patientNameColumn) {
    const originalRender = patientNameColumn.render;
    patientNameColumn.render = (text, record) => originalRender(text, record, openReportEditor, openViewer, openRadiantViewer, enableRadiantViewer);
  }

  // Customize technician assignment column
  const techAssignColumn = pacsSpecificColumns.find(col => col.key === 'assigned_to_tech');
  if (techAssignColumn) {
    const originalRender = techAssignColumn.render;
    techAssignColumn.render = (text, record, ind) => originalRender(text, record, ind, assignToSelfTechnician);
  }

  // Customize radiologist assignment column
  const radAssignColumn = pacsSpecificColumns.find(col => col.key === 'assigned_radiologist');
  if (radAssignColumn) {
    const originalRender = radAssignColumn.render;
    radAssignColumn.render = (text, record, ind) => originalRender(text, record, ind, handleRadiologistAssignment, userList);
  }

  // Action column configuration
  const actionConfig = {
    openViewer,
    showOrdDetails,
    openRadDesk,
    openReportEditor,
    addFile,
    viewNotes,
    printReport,
    downloadDocxReport,
    viewReport,
    editSignedOffReport,
    handleShareStudy,
    handleDownloadStudy,
    editStudyDetails,
    showStudyHistory,
    assignToSelfTechnician,
    toggleReporting,
    toggleConfirmation,
    toggleFeatures,
    role,
    pageType: 'pacs'
  };

  const actionsColumn = {
    title: FieldLabels.ACTIONS,
    key: "actions_column",
    render: renderActionColumn(actionConfig),
    width: calculateActionsColumnWidth(actionConfig),
  };

  return [
    ...baseColumns,
    ...pacsSpecificColumns,
    actionsColumn
  ].filter(itm => !itm.hidden);
};
